import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

// Constants
const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'hi', label: 'हिं' },
  { code: 'mr', label: 'मरा' }
];

// Helper functions extracted from component
const getButtonStyles = (isActive, isScrolled) => {
  const baseColor = isScrolled ? '#64748b' : 'rgba(255, 255, 255, 0.9)';
  
  return {
    backgroundColor: isActive ? 'var(--medical-primary)' : 'transparent',
    color: isActive ? '#ffffff' : baseColor,
    textShadow: (!isScrolled && !isActive) ? '0 1px 2px rgba(0,0,0,0.2)' : 'none'
  };
};

const getContainerStyles = (isScrolled) => ({
  backgroundColor: isScrolled ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.1)',
  borderColor: isScrolled ? 'rgba(5, 56, 39, 0.15)' : 'rgba(255, 255, 255, 0.2)'
});

const LanguageSwitcher = ({ isScrolled = true }) => {
  const { i18n } = useTranslation();

  const changeLanguage = useCallback((lng) => {
    i18n.changeLanguage(lng);
  }, [i18n]);

  const containerStyles = getContainerStyles(isScrolled);
  const iconColor = isScrolled ? '#64748b' : '#ffffff';
  const separatorColor = isScrolled ? '#e2e8f0' : 'rgba(255, 255, 255, 0.3)';

  return (
    <div 
      className="flex items-center gap-0.5 backdrop-blur-sm rounded-full px-2 py-1 border transition-all duration-300"
      style={containerStyles}
    >
      <Globe size={14} className="mr-1 transition-colors" style={{ color: iconColor }} />
      {LANGUAGES.map((lang, index) => {
        const isActive = i18n.language === lang.code;
        
        return (
          <React.Fragment key={lang.code}>
            <button
              onClick={() => changeLanguage(lang.code)}
              className={`px-1.5 py-0.5 text-xs font-semibold rounded transition-all duration-200 ${
                isActive ? '' : 'hover:opacity-70'
              }`}
              style={getButtonStyles(isActive, isScrolled)}
              aria-label={`Switch to ${lang.code}`}
              aria-current={isActive ? 'true' : 'false'}
            >
              {lang.label}
            </button>
            {index < LANGUAGES.length - 1 && (
              <span className="text-xs mx-0.5" style={{ color: separatorColor }}>|</span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
